<template>
    <div v-if="allFiltersLength" class="search-header" style="text-align: center;">
        <div
            v-if="showResultsButton"
            @click="searchHandle"
            class="search-show-button">Показать результаты</div>
        <div>
            <div @click="resetHandle" class="search-erase-button">
                <i class="lnr lnr-cross"></i> Сбросить все настройки поиска
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['clear'],
    methods: {
        searchHandle(e){
            // this.showButton = false
            this.$store.commit('search/resetPage')
            this.$store.commit('search/updateSearchObject', {obj: 'showResultsButton', value: false})
            this.$props.clear()
            this.$store.dispatch('search/getCards')
        },
        resetHandle(){ this.$store.dispatch('search/resetFilterData') }
    },
    computed: {
        // сделедить за изменениями в длинне фильтров, чтобы показывать кнопку не получеается
        status(){
            return this.$store.getters['search/selectedFiltersCount'].status
        },
        rectype(){
            return this.$store.getters['search/selectedFiltersCount'].rectype
        },
        allFiltersLength(){
            return this.$store.getters['search/selectedFiltersCount'].allFiltersLength
        },
        showResultsButton(){
            return this.$store.state.search.showResultsButton
        },
        dateStartStopToWatch(){
            var dateStart = this.$store.state.search.filterData.dateStart
            var dateStop = this.$store.state.search.filterData.dateStop
            return dateStart.from + dateStart.to + dateStop.from + dateStop.to
        }
    },
    watch: {
        allFiltersLength(value) {
            this.$store.commit('search/setFilterData', { type: "address", value: '' })
            this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value })
        },
        rectype(val) {
            if(val) {
                this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: true })
            }
            this.$store.commit('search/setFilterData', { type: "address", value: '' })
        },
        status(val) {
            if(val == 'curr' || val == 'liqu') {
                this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: true })
            }
            this.$store.commit('setFilterData', { type: "address", value: '' })
        },
        dateStartStopToWatch(val){
            this.$store.commit('search/setFilterData', { type: "address", value: '' })
            this.$store.commit('search/updateSearchObject', { obj: 'showResultsButton', value: true })
        }
    }
}
</script>

<style scoped>
.search-erase-button {
    display: inline-block;
    font-size: 14px;
    color: rgb(204, 0, 0);
    cursor: pointer;
    margin-bottom: 30px;
}
.search-show-button {
    display: inline-block;
    background: #F5D76E;
    padding: 10px 20px;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
    border-radius: 4px;
    margin: 0 auto 15px;
}

#search-show.busy {
    background: #ddd;
    color: #999;
    cursor: default;
}
</style>